var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrowGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.81 45.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6cb156;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOME"
  }, /*#__PURE__*/React.createElement("g", {
    id: "key_research_papers",
    "data-name": "key research papers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_17",
    "data-name": "Layer 17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.73,24.6,21,44.9a2.5,2.5,0,0,0,3.53,0l1.49-1.49a2.5,2.5,0,0,0,0-3.53L9,22.83,26.08,5.75a2.5,2.5,0,0,0,0-3.53L24.58.73a2.5,2.5,0,0,0-3.53,0L.73,21.05A2.53,2.53,0,0,0,0,22.83,2.49,2.49,0,0,0,.73,24.6Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowGreen);
export default __webpack_public_path__ + "static/media/left_arrow_green.1ffc2a12cba9c1aa8c425d81e4568837.svg";
export { ForwardRef as ReactComponent };